import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReportsReferralAccountsResolverErrorStatesEnum {
    GetReferrralAccountsFailed = ErrorStateScheduleEnum.PanelReportsReferralAccountsResolverErrorStatesStartIndex
}